var singleTestimonialSwiperList = {}

const createSingleTestimonialSwiper = (unique_selector) => {
	if (singleTestimonialSwiperList[unique_selector]) {
		singleTestimonialSwiperList[unique_selector].destroy(true, true)
	}

	singleTestimonialSwiperList[unique_selector] = new Swiper(unique_selector, {
		grabCursor: true,
		centeredSlides: true,
		loop: true,
		slidesPerView: 'auto',
		spaceBetween: 10,
		direction: 'vertical',
		autoHeight: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false
		},
		on: {
			init: function () {
				// Calculate and set the maximum height during initialization
				let maxHeight = 0
				this.slides.forEach((slide) => {
					maxHeight = Math.max(maxHeight, slide.offsetHeight)
				})
				this.slides.forEach((slide) => {
					slide.style.minHeight = `${maxHeight}px`
				})
				this.el.style.height = `${maxHeight}px`
			},
			slideChange: function () {
				// // Re-apply the maximum height during each slide change
				// let maxHeight = parseFloat(this.el.style.height)
				// this.el.style.height = `${maxHeight}px`
			},
			resize: function () {
				// Recalculate the maximum height on window resize
				let maxHeight = 0
				this.slides.forEach((slide) => {
					maxHeight = Math.max(maxHeight, slide.offsetHeight)
				})
				this.slides.forEach((slide) => {
					slide.style.minHeight = `${maxHeight}px`
				})
				this.el.style.height = `${maxHeight}px`
			}
		}
	})

	// console.log(unique_selector, singleTestimonialSwiperList[unique_selector].slides)
}
